export type Industry = {
  name: string
  focus: string
  size: 'lg' | 'md' | 'sm'
  accent: 'orange' | 'green' | 'cyan' | 'blue'
}

export const industries: Industry[] = [
  { name: 'Apparel & printing', focus: 'Custom order forms, artwork uploads, online store', size: 'lg', accent: 'orange' },
  { name: 'Bathroom remodeling', focus: 'Project galleries, quote requests, service areas', size: 'md', accent: 'cyan' },
  { name: 'Martial arts', focus: 'Class schedules, trial signups, membership pages', size: 'sm', accent: 'green' },
  { name: 'Auto service', focus: 'Appointment booking, service menus, local structure', size: 'md', accent: 'blue' },
  { name: 'Marine', focus: 'Inventory listings, parts enquiries, seasonal service', size: 'sm', accent: 'cyan' },
  { name: 'Industrial', focus: 'Capability pages, spec libraries, RFQ workflows', size: 'lg', accent: 'orange' },
  { name: 'Chiropractic', focus: 'New patient intake, provider pages, online booking', size: 'sm', accent: 'green' },
  { name: 'Retail & ecommerce', focus: '0% transaction fees, catalog builds, inventory APIs', size: 'md', accent: 'orange' },
  { name: 'Fitness', focus: 'Memberships, trainer profiles, schedule integrations', size: 'sm', accent: 'blue' },
]
